@use '../../../scss/utility';

:host {
  display: block;
}

:host([tag='span']),
:host([tag='b']),
:host([tag='em']),
:host([tag='i']),
:host([tag='strong']),
:host([tag='small']) {
  display: inline;
}

.tag {
  @include utility.wb-type-normalizing;
  font: inherit;
  box-shadow: border-box;
  margin: 0;
}

:host([ellipsis]) {
  overflow: hidden;

  .tag {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@each $size in ('s', 'm', 'l') {
  :host([size='#{$size}'][static]) {
    @include utility.wb-text(
      $size,
      (
        strong: false,
        responsive: false,
        includeSupStyles: false,
        includeNormalizations: false,
      )
    );
  }

  :host([size='#{$size}']:not([static])) {
    @include utility.wb-text(
      $size,
      (
        strong: false,
        responsive: true,
        includeSupStyles: false,
        includeNormalizations: false,
      )
    );
  }

  :host([size='#{$size}'][static][strong]) {
    @include utility.wb-text-strong($size, false);
  }

  :host([size='#{$size}']:not([static])[strong]) {
    @include utility.wb-text-strong($size, true);
  }
}

::slotted(sup) {
  @include utility.wb-superscript;
}

::slotted(sub) {
  @include utility.wb-subscript;
}
